import { getAPIURL } from "./config.js";

export const aqFetch = (path, params) => {
  return fetch(`${getAPIURL()}${path}`, {
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    ...params,
  });
};

export const getAllNews = async () => {
  try {
    const response = await aqFetch("posts/all");
    if (!response.ok) {
      throw new Error("Ошибка при получении новостей");
    }
    const data = await response.json();
    return data.posts;
  } catch (error) {
    console.error("Ошибка:", error);
    return [];
  }
};

export const createNews = async (formData) => {
  try {
    // Отладка - проверим содержимое FormData
    console.log("Отправляемые данные:");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    const response = await fetch(`${getAPIURL()}posts/add`, {
      method: "POST",
      credentials: "include",
      body: formData,
    });

    if (!response.ok) {
      // Сначала проверим, является ли ответ JSON
      const text = await response.text();
      let errorMessage;
      try {
        const errorData = JSON.parse(text);
        errorMessage = errorData.detail || "Ошибка при создании новости";
      } catch {
        errorMessage = `Ошибка сервера: ${text}`;
      }
      throw new Error(errorMessage);
    }

    return await response.json();
  } catch (error) {
    console.error("Детали ошибки:", error);
    throw error;
  }
};

export const deleteNews = async (postId) => {
  try {
    const response = await aqFetch(`posts/${postId}/delete`, {
      method: "PUT",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || "Ошибка при удалении новости");
    }

    return await response.json();
  } catch (error) {
    console.error("Ошибка:", error);
    throw error;
  }
};

export const updateNews = async (postId, formData) => {
  try {
    const response = await fetch(`${getAPIURL()}posts/update/${postId}`, {
      method: "PUT",
      credentials: "include",
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || "Ошибка при обновлении новости");
    }

    return await response.json();
  } catch (error) {
    console.error("Ошибка:", error);
    throw error;
  }
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return "";

  // Всегда используем IP сервера для изображений
  const baseUrl = "https://test.portal.akmolpro.kz/api/";

  // Убираем начальный слеш, если он есть
  const cleanPath = imagePath.startsWith("/") ? imagePath.slice(1) : imagePath;

  // Если путь уже содержит AQ_posts, не добавляем его снова
  const fullPath = cleanPath.includes("AQ_posts")
    ? cleanPath
    : `AQ_posts/${cleanPath}`;

  // Формируем полный URL и убираем двойные слеши
  return `${baseUrl}/${fullPath}`.replace(/([^:]\/)\/+/g, "$1");
};
